
var accordions = document.getElementsByClassName("collapisible-details-summary");
  for (var i = 0; i < accordions.length; i++) {  
    accordions[i].addEventListener("click", function() {
      this.classList.add("open");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
        this.classList.remove("open");
      } else {
        // Close all open panels before opening the clicked panel
        for (var j = 0; j < accordions.length; j++) {
          var openPanel = accordions[j].nextElementSibling;
          if (openPanel.style.display === "block") {
            openPanel.style.display = "none";
            accordions[j].classList.remove("open");            
          }
        }
        panel.style.display = "block";
      }
    });
  }